import { defineComponent as _defineComponent } from 'vue'
import { AccountModal } from '@/lazy-load-components';
import BasicButton from '@/ui-components/BasicButton.vue';
import { ModalHelper } from '@/helpers/modal-helper';
import { useUserStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginButton',
  props: {
    location: { default: '' }
  },
  setup(__props: any) {



const { isLoggedIn, setLoginProgress } = useUserStore();

function openModal() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
		setLoginProgress(false)
	);
}

return { __sfc: true,isLoggedIn, setLoginProgress, openModal, BasicButton }
}

})